export default {
    universe: state => state.universe,
    universe_id: state => state.universe_id,
    routes_restrictions: state => state.universe.routes_restrictions,
    affiliation_reset_cache: state => state.affiliation_reset_cache,
    affiliation_refresh_next_page: state => state.affiliation_refresh_next_page
};
